import { FieldErrors } from 'react-hook-form';
import { JobTask, JobTaskStatus } from '@root/globalTypes';
import { ExternalScheduleFormValues } from '@forms/schedules/external/types';
import { ExternalScheduleDialogType } from './types';
import { visibleFields } from './constants';

export const getHiddenErrorFields = (
  errors: FieldErrors<ExternalScheduleFormValues>,
  type: ExternalScheduleDialogType,
) =>
  Object.keys(errors).filter(
    (key) => !visibleFields[type].includes(key as keyof ExternalScheduleFormValues),
  );

const HIDDEN_PILL_STATUSES: JobTaskStatus[] = ['to_schedule', 'not_started', 'incomplete'];

export const getRelatedTasks = (tasks: JobTask[] = [], taskId?: string) =>
  tasks.filter(
    (task) =>
      task.id !== taskId &&
      Boolean(task.schedule?.startsAt) &&
      Boolean(task.status && !HIDDEN_PILL_STATUSES.includes(task.status)),
  );
